var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.75,
    height: 25.75,
    viewBox: "0 0 25.75 25.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2522",
    "data-name": "Group 2522",
    transform: "translate(-282 -350)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-first-5181176",
    d: "M141.856,58.976V53.639H136.52l-3.77-3.77-3.77,3.77h-5.336v5.336l-3.77,3.77,3.77,3.77v1.43H125.6V65.7l-2.967-2.957,2.967-2.957V55.6h4.19l2.957-2.967,2.957,2.967h4.19v4.19l2.967,2.957L139.9,65.7v4.19h-4.19l-2.957,2.967-2.957-2.967h-6.149v1.958h5.336l3.77,3.77,3.77-3.77h5.336V66.515l3.77-3.77Z",
    transform: "translate(162.125 300.13)",
    fill: "#68d808"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(291 366)",
    fill: "#68d808",
    fontSize: 13,
    fontFamily: "MyanmarMN-Bold, Myanmar MN",
    fontWeight: 700,
    letterSpacing: "0.005em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondIcon);
export default __webpack_public_path__ + "static/media/second_icon.e9fbdd8155f5e2378b2b167e27b9d9d5.svg";
export { ForwardRef as ReactComponent };